import styled from 'styled-components'

const GallerySliderStyle = styled.section`
	--gallerySectionMTop: var(--sp8x);
	--slideWidth: 50%;
	--fileHeight: 56.4%;

	overflow: hidden;
	margin-top: calc(calc(var(--roundButtonCursorSize) / -2) + var(--gallerySectionMTop));
	margin-bottom: calc(var(--roundButtonCursorSize) / -2);

	.gs-slider-container {
		position: relative;
		margin: 0 calc(var(--colPadding) / -2 - var(--contPaddingLR)) calc(var(--roundButtonCursorSize) / 2);
		margin-top: calc(var(--roundButtonCursorSize) / 2);

		.gs-slider-inner-container {
			overflow-x: hidden;

			.swiper {
				overflow: visible;
				cursor: ${(props) => (props.imagesQuantity > props.dragNumberSize ? 'none' : 'default')};
				margin: 0 var(--contPaddingLR);

				.swiper-slide {
					width: var(--slideWidth);
					padding: 0 calc(var(--colPadding) / 2);
					height: auto;
					pointer-events: none;
					cursor: ${(props) => (props.imagesQuantity > props.dragNumberSize ? 'none' : 'default')};

					.gs-slide {
						height: 100%;
						pointer-events: all;

						* {
							cursor: ${(props) => (props.imagesQuantity > props.dragNumberSize ? 'none' : 'default')};
						}

						.image-cont,
						.video-cont {
							padding-top: var(--fileHeight);

							img,
							video {
								border-radius: var(--borderRadiusSize);
							}
						}
					}
				}
			}
		}

		.gs-drag-container {
			position: absolute;
			z-index: 3;
			pointer-events: none;
			transform: scale(0);

			@media (hover: none) {
				display: none;
			}

			.gs-drag {
				position: absolute;
				top: 0;
				left: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				width: var(--roundButtonCursorSize);
				height: var(--roundButtonCursorSize);
				border-radius: 50%;
				color: var(--bodyColor);
				background-color: var(--primaryColor9);
				transform: translate(-50%, -50%);
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--gallerySectionMTop: var(--sp7x);
		--fileHeight: 56.5%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--gallerySectionMTop: var(--sp6x);
		--fileHeight: 56.6%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--gallerySectionMTop: var(--sp6x);
		--fileHeight: 56.3%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--gallerySectionMTop: var(--sp5x);
		--slideWidth: 55.4%;
		--fileHeight: 57%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--gallerySectionMTop: var(--sp5x);
		--slideWidth: 66.7%;
		--fileHeight: 56.3%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--gallerySectionMTop: var(--sp5x);
		--slideWidth: 91.7%;
		--fileHeight: 56.4%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--gallerySectionMTop: var(--sp4x);
		--slideWidth: 88%;
		--fileHeight: 75%;
	}
`

export default GallerySliderStyle
